import React, { useCallback, useState } from 'react';
import { usePopper } from 'react-popper';
import { Box } from 'reflexbox';
import { ColorSelector, ColorSelectorOptions, Float, Prompt } from '.';
import { promptName } from '../CodesThatsGottaGoSomewhereElse';
import { PopperInner, PopperMount, PopperPortal } from '../app/canvas/ui/PopperElements';
import { ColorPreview } from './ColorPreview';

export type ColorButtonProps = ColorSelectorOptions & { portal?: boolean, value?: string, onChange: (value?: string) => void };

const MaybePortal = ({ portal, children }: { portal?: boolean, children: React.ReactNode }) => {
    return portal ? <PopperPortal>{children}</PopperPortal> : <>{children}</>;
};

export const ColorButton = ({ portal, value, onChange, ...opts }: ColorButtonProps) => {

    const [refElmt, setRefElmt] = useState(null);
    const [popElmt, setPopElmt] = useState(null);

    const { styles, attributes } = usePopper(refElmt, popElmt, {
        placement: 'right',
    });

    const pn = promptName();
    const [open, setOpen] = useState(false);
    const onOpen = useCallback(() => setOpen(!open), [open, setOpen]);
    const onClose = useCallback(() => setOpen(false), [setOpen]);

    const onSelect = useCallback((color: string | null, complete: boolean) => {
        onChange(color);
        if (complete) {
            onClose();
        }
    }, [onChange, onClose]);

    return <>
        <ColorPreview clickable color={value} ref={setRefElmt} className={`ignore-${pn}`} onClick={onOpen} />
        {open && <MaybePortal portal={portal}>
            <PopperMount ref={setPopElmt} className={`ignore-${prompt}`} style={styles.popper} {...attributes.popper}>
                <Prompt name={pn} ignoreEnter onAction={() => setOpen(false)}>
                    <PopperInner direction="right">
                        <Box padding="0 .5">
                            <Float shadow="lg">
                                <ColorSelector color={value} {...opts} onSelect={onSelect} />
                            </Float>
                        </Box>
                    </PopperInner>
                </Prompt>
            </PopperMount>
        </MaybePortal>}
    </>;
};
